<ul class="list list-scrollable history-list">
    @for (item of history$|async; track i; let i = $index) {
        <li>
            <button (click)="handleHistoryItemClick(item)" [attr.data-qa]="'history-'+item.id" class="button button-list-item list-item history-item">
                @if (item.svg) {
                    <app-icon [iconSize]="AppIconSizeEnum.MEDIUM" [svgIcon]="item.svg" class="list-item-icon"/>
                } @else if (item.icon) {
                    <app-icon [iconSize]="AppIconSizeEnum.MEDIUM" [iconUrl]="item.icon.includes('assets')? item.icon:item.icon|authImage" class="list-item-icon"/>
                } @else {
                    <app-icon [iconSize]="AppIconSizeEnum.MEDIUM" [svgIcon]="ICONS.TIMELINE" class="list-item-icon fallback-history-item-icon"/>
                }

                <div class="list-item-title-group">
                    <div class="list-item-text list-item-title">{{ item.title|translate }}</div>
                    @if (item.subTitle) {
                        <div class="list-item-text list-item-subtitle">{{ item.subTitle|translate }}</div>
                    }
                </div>
            </button>
        </li>
    }
    <app-button (clicked)="hideOverlay()"
                [appButtonType]="AppButtonTypeEnum.ICON_ONLY_BUTTON"
                [buttonColor]="ButtonColorEnum.CUSTOM_DARK_HOVER"
                [buttonText]="'BUTTON.CLOSE' | translate"
                [svgIcon]="ICONS.CLOSE"
                class="close-history-button"
                qaTag="close-history"/>
</ul>
